import './style.scss';

import type { ReactNode } from 'react';

/**
 * The app's status vocabulary. Every tone maps to a semantic token pair, so dark mode
 * comes for free and no rule ever needs an `rgba()` over a `var()`.
 */
export type StatusTone = 'success' | 'warning' | 'danger' | 'info' | 'neutral';

export interface IStatusBadge {
	label: string;
	tone?: StatusTone;
	/**
	 * `soft` — a tinted pill, the default and the right choice almost everywhere.
	 * `solid` — a filled pill, for the one badge that must win against a busy surface.
	 * `text` — an uppercase, letter-spaced label with no chrome, for dense rows where
	 * a pill per line would read as noise.
	 */
	variant?: 'soft' | 'solid' | 'text';
	icon?: ReactNode;
	size?: 'sm' | 'md';
	/** Native tooltip for the cases where the label has to stay short. */
	title?: string;
	className?: string;
}

export const StatusBadge = ({
	label,
	tone = 'neutral',
	variant = 'soft',
	icon,
	size = 'md',
	title,
	className = '',
}: IStatusBadge) => (
	<span
		className={`status-badge status-badge--${tone} status-badge--${variant} status-badge--${size} ${className}`.trim()}
		title={title}
	>
		{icon ? <span className='status-badge__icon'>{icon}</span> : null}
		{label}
	</span>
);

export default StatusBadge;
